import React from 'react';
import { useNavigate } from 'react-router-dom';
import { THEME } from '../../config/brand';
import G1Image from '../../assets/images/Gradecards/G1.jpg';
import G2Image from '../../assets/images/Gradecards/G2.jpg';
import G3Image from '../../assets/images/Gradecards/G3.jpg';

interface GradeCard {
  id: string;
  grade: string;
  title: string;
  route: string;
  image: string;
}

const gradeCards: GradeCard[] = [
  {
    id: 'g1',
    grade: 'Secondary1',
    title: 'الصف الأول الثانوي',
    route: '/courses/grade/secondary1',
    image: G1Image,
  },
  {
    id: 'g2',
    grade: 'Secondary2',
    title: 'الصف الثاني الثانوي',
    route: '/courses/grade/secondary2',
    image: G2Image,
  },
  {
    id: 'g3',
    grade: 'Secondary3',
    title: 'الصف الثالث الثانوي',
    route: '/courses/grade/secondary3',
    image: G3Image,
  },
];

const GradeCards: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto grid max-w-6xl grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
      {gradeCards.map((card) => (
        <button
          key={card.id}
          type="button"
          onClick={() => navigate(card.route, { state: { grade: card.grade } })}
          className="group relative overflow-hidden rounded-[1.75rem] text-right transition duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] hover:-translate-y-1.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2"
          style={{
            border: `2px solid ${THEME.black}`,
            boxShadow: '4px 4px 0 rgba(0, 0, 49, 0.12)',
            background: THEME.surface,
          }}
          dir="rtl"
          lang="ar"
          aria-label={card.title}
        >
          <img
            src={card.image}
            alt={card.title}
            className="h-auto w-full object-cover transition duration-500 group-hover:scale-[1.02]"
            loading="lazy"
          />
        </button>
      ))}
    </div>
  );
};

export default GradeCards;
